<ng-template #modalSyncSuccess let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      Integração {{ laudoVisualizacao?.titulo }}
    </h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-12">
      <label class="mt-4">Data Envio:</label>
    </div>

    <div class="col-12">
      <label class="mt-4">{{
        laudoVisualizacao?.dataenviointegracao | date: "dd/MM/yyyy HH:mm"
      }}</label>
    </div>

    <div class="col-12">
      <label class="mt-4">PDF enviado:</label>
    </div>

    <div class="col-12">
      <div class="d-flex align-items-center">
        <span
          data-toggle="tooltip"
          data-placement="bottom"
          title="Visualizar laudo em PDF"
        >
          <a
            [attr.href]="laudoVisualizacao?.urlpdfintegracao"
            rel="noopener noreferrer"
            target="_blank"
            class="btn btn-sm btn-danger btn-icon"
          >
            <i class="mdi mdi-file-pdf"></i>
          </a>
        </span>
      </div>
    </div>

    <div class="col-12">
      <label class="mt-4">Status:</label>
    </div>

    <div class="col-12">
      <label class="mt-4">{{ laudoVisualizacao?.statusintegracao }}</label>
    </div>

    <div class="col-12">
      <label class="mt-4">Mensagem:</label>
    </div>

    <div class="col-12">
      <label class="mt-4">{{ laudoVisualizacao?.msgstatusintegracao }}</label>
    </div>

    
    <div class="col-12">
      <label class="mt-4">LOG retorno:</label>
    </div>

    <div class="col-12">
      <label>{{ laudoVisualizacao?.logintegracao }}</label>
    </div>

    <div class="col-12">
      <label class="mt-4">Payload enviado:</label>
    </div>

    <div class="col-12">
      <label>{{ laudoVisualizacao?.payloadintegracao }}</label>
    </div>
  </div>
</ng-template>

<ng-template #modalSyncError let-modal>
  <div class="modal-header">
    <h2 class="modal-title" id="modal-basic-title">
      Integração {{ laudoVisualizacao?.titulo }}
    </h2>
    <button
      type="button"
      class="btn btn-sm btn-danger rounded-circle"
      aria-label="Close"
      (click)="modal.dismiss(false)"
    >
      <i class="mdi mdi-close f-20"></i>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-12">
      <label class="mt-4">Data Envio:</label>
    </div>

    <div class="col-12">
      <label>{{
        laudoVisualizacao?.dataenviointegracao | date: "dd/MM/yyyy HH:mm"
      }}</label>
    </div>

    <div class="col-12">
      <label class="mt-4">PDF enviado:</label>
    </div>

    <div class="col-12">
      <div class="d-flex align-items-center">
        <span
          data-toggle="tooltip"
          data-placement="bottom"
          title="Visualizar laudo em PDF"
        >
          <a
            [attr.href]="laudoVisualizacao?.urlpdfintegracao"
            rel="noopener noreferrer"
            target="_blank"
            class="btn btn-sm btn-danger btn-icon"
          >
            <i class="mdi mdi-file-pdf"></i>
          </a>
        </span>
      </div>
    </div>

    <div class="col-12">
      <label class="mt-4">Status:</label>
    </div>

    <div class="col-12">
      <label>{{ laudoVisualizacao?.statusintegracao }}</label>
    </div>

    <div class="col-12">
      <label class="mt-4">MSG retorno:</label>
    </div>

    <div class="col-12">
      <label>{{ laudoVisualizacao?.msgstatusintegracao }}</label>
    </div>

    <div class="col-12">
      <label class="mt-4">LOG retorno:</label>
    </div>

    <div class="col-12">
      <label>{{ laudoVisualizacao?.logintegracao }}</label>
    </div>

    <div class="col-12">
      <label class="mt-4">Payload enviado:</label>
    </div>

    <div class="col-12">
      <label>{{ laudoVisualizacao?.payloadintegracao }}</label>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="modal.close(true)">
      Reenviar
    </button>
  </div>
</ng-template>

<ng-template #modalHG let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      Integração HG
    </h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="col-12">
      <label class="mt-4">Logs:</label>
    </div>

    <div class="col-12">
      <label class="mt-4">{{ laudoVisualizacao?.log_hg }}</label>
    </div>

    <div class="col-12">
      <label class="mt-4">Payload enviado:</label>
    </div>

    <div class="col-12">
      <label class="mt-4">{{ laudoVisualizacao?.payload_hg }}</label>
    </div>
  </div>
</ng-template>

<section class="py-4">
  <div class="row mx-2">
    <div class="col-12 col-sm-6 col-xl-2 pb-2 px-3">
      <label for="laudoid">ID Laudo</label>
      <input
        [formControl]="form.controls.id"
        id="laudoid"
        type="number"
        class="form-control"
      />
    </div>

    <div class="col-12 col-sm-6 col-xl-2 pb-2 px-3">
      <label for="placa">Placa</label>
      <input
        [formControl]="form.controls.placa"
        [textMask]="masks.placa"
        id="placa"
        class="form-control"
      />
    </div>

    <div class="col-12 col-sm-6 col-xl-2 pb-2 px-3">
      <label for="tipolaudo">Tipo de laudo</label>
      <select
        [formControl]="form.controls.tipolaudo"
        id="tipolaudo"
        type="text"
        class="form-control"
      >
        <option *ngFor="let o of listaTipoLaudo" [value]="o.id">
          {{ o.nome }}
        </option>
      </select>
    </div>

    <div class="col-12 col-sm-6 col-xl-3 pb-2 px-3">
      <label for="cliente">Cliente</label>
      <select
        [formControl]="form.controls.cliente"
        id="cliente"
        type="text"
        class="form-control"
      >
        <option *ngFor="let o of listaClientes" [value]="o.id">
          {{ o.nomefantasia }}
        </option>
      </select>
    </div>

    <div class="col-12 col-sm-6 col-xl-3 pb-2 px-3">
      <label for="unidade">Unidade</label>
      <select
        [formControl]="form.controls.unidade"
        id="unidade"
        type="text"
        class="form-control"
      >
        <option *ngFor="let o of listaUnidades" [value]="o.id">
          {{ o.nomefantasia }}
        </option>
      </select>
    </div>

    <div class="col-12 col-sm-6 col-xl-2 pb-2 px-3">
      <app-date-interval
        [(inicio)]="params.filter.dataInicio"
        [(fim)]="params.filter.dataFim"
        (fimChange)="updateResult()"
        (inicioChange)="updateResult()"
      ></app-date-interval>
    </div>

    <div class="col-12 col-sm-6 col-xl-2 pb-2 px-3">
      <label for="parecertecnico">Parecer Técnico</label>
      <select
        [formControl]="form.controls.parecertecnico"
        id="parecertecnico"
        type="text"
        class="form-control"
      >
        <option *ngFor="let p of parecerTecnico" [value]="p.id">
          {{ p.nome }}
        </option>
      </select>
    </div>

    <div class="w-100 px-3 pt-3 row">
      <div class="btn-group col-12">
        <button
          [ngClass]="{ 'btn-theme': params.filter.status == '' }"
          (click)="setSituacaoLaudo('')"
          class="btn"
        >
          Todos
        </button>
        <button
          [ngClass]="{ 'btn-theme': params.filter.status == '2' }"
          (click)="setSituacaoLaudo('2')"
          class="btn"
        >
          Agendados
        </button>
        <button
          [ngClass]="{ 'btn-theme': params.filter.status == '0' }"
          (click)="setSituacaoLaudo('0')"
          class="btn"
        >
          Em Andamento
        </button>
        <button
          [ngClass]="{ 'btn-theme': params.filter.status == '1' }"
          (click)="setSituacaoLaudo('1')"
          class="btn"
        >
          Finalizados
        </button>
      </div>
      <div class="text-right col-12">
        Foram encontrados {{ total }} registro(s).
      </div>
    </div>
  </div>

  <div *ngIf="tableLoading" class="mx-2 my-4 mx-lg-4 card">
    <div
      *ngIf="tableLoading"
      class="p-5 d-flex justify-content-center position-relative"
    >
      <i class="mdi mdi-loading rotate-animation f-80 text-primary"></i>
    </div>
  </div>

  <div *ngIf="!tableLoading" class="mx-2 my-4 mx-lg-4 card">
    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Marca</th>
            <th>Modelo</th>
            <th>#</th>
            <th
              [tableOrderGroup]="params.sorting"
              [(tableOrder)]="params.sorting.nometipolaudo"
              (tableOrderChange)="changeOrder()"
            >
              Tipo Laudo
            </th>
            <th
              [tableOrderGroup]="params.sorting"
              [(tableOrder)]="params.sorting.nomecliente"
              (tableOrderChange)="changeOrder()"
              class="text-center"
            >
              Cliente
            </th>
            <th
              [tableOrderGroup]="params.sorting"
              [(tableOrder)]="params.sorting.nomeunidade"
              (tableOrderChange)="changeOrder()"
              class="text-center"
            >
              Unidade
            </th>
            <th
              [tableOrderGroup]="params.sorting"
              [(tableOrder)]="params.sorting.nomeusuario"
              (tableOrderChange)="changeOrder()"
              class="text-center"
            >
              Vistoriador
            </th>
            <th
              [tableOrderGroup]="params.sorting"
              [(tableOrder)]="params.sorting.placa"
              (tableOrderChange)="changeOrder()"
              class="text-center"
            >
              Placa
            </th>
            <th
              [tableOrderGroup]="params.sorting"
              [(tableOrder)]="params.sorting.datacriacao"
              (tableOrderChange)="changeOrder()"
              class="text-center"
            >
              Criado em
            </th>
            <th
              [tableOrderGroup]="params.sorting"
              [(tableOrder)]="params.sorting.dataultimaatualizacao"
              (tableOrderChange)="changeOrder()"
              class="text-center"
            >
              Atualizado em
            </th>
            <th
              [tableOrderGroup]="params.parecertecnico"
              [(tableOrder)]="params.sorting.parecertecnico"
              (tableOrderChange)="changeOrder()"
            >
              Parecer
            </th>
            <th
              [tableOrderGroup]="params.sorting"
              [(tableOrder)]="params.sorting.status"
              (tableOrderChange)="changeOrder()"
              class="text-center"
            >
              Status
            </th>
            <th class="text-center">Integrações</th>
            <th class="text-right py-2">
              <button class="btn btn-sm btn-success" (click)="downloadExcel()">
                <i class="mdi mdi-download"></i> Download Excel
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="listaResultado.length == 0">
            <td class="text-center py-5 text-secondary w-500" colspan="11">
              Sem registros
            </td>
          </tr>
          <tr *ngFor="let r of listaResultado">
            <td>
              <img
                width="30px"
                src="assets/images/marcas/{{ r.fabricante }}.png"
                alt=""
              />
            </td>
            <td>{{ r.modelo }}</td>
            <td>{{ r.id }}</td>
            <td>{{ r.nometipolaudo }}</td>
            <td>{{ r.nomecliente || "PARTICULAR" }}</td>
            <td>{{ r.nomeunidade }}</td>
            <td>{{ r.nomeusuario }}</td>
            <td>{{ r.placa }}</td>
            <td>{{ r.datacriacao | date: "dd/MM/yyyy HH:mm" }}</td>
            <td>{{ r.dataultimaatualizacao | date: "dd/MM/yyyy HH:mm" }}</td>
            <td>
              <!-- parecer 1 -->
              {{
                r?.parecertecnico == 1 &&
                r?.nomenclatura == "nomenclaturaParecer1"
                  ? "APROVADO"
                  : ""
              }}
              {{
                r?.parecertecnico == 1 &&
                r?.nomenclatura == "nomenclaturaParecer2"
                  ? "CONFORME"
                  : ""
              }}
              {{
                r?.parecertecnico == 1 &&
                r?.nomenclatura == "nomenclaturaParecer3"
                  ? "CONFORME"
                  : ""
              }}
              {{
                r?.parecertecnico == 1 &&
                r?.nomenclatura == "nomenclaturaParecer4"
                  ? "SEM APONTAMENTO"
                  : ""
              }}
              <!-- parecer 2 -->
              {{
                r?.parecertecnico == 2 &&
                r?.nomenclatura == "nomenclaturaParecer1"
                  ? "APROVADO COM RESTRIÇÃO"
                  : ""
              }}
              {{
                r?.parecertecnico == 2 &&
                r?.nomenclatura == "nomenclaturaParecer2"
                  ? "CONFORME COM RESTRIÇÃO"
                  : ""
              }}
              {{
                r?.parecertecnico == 2 &&
                r?.nomenclatura == "nomenclaturaParecer3"
                  ? "COM RESTRIÇÃO"
                  : ""
              }}
              <!-- parecer 3 -->
              {{
                r?.parecertecnico == 3 &&
                r?.nomenclatura == "nomenclaturaParecer1"
                  ? "APROVADO COM APONTAMENTO"
                  : ""
              }}
              {{
                r?.parecertecnico == 3 &&
                r?.nomenclatura == "nomenclaturaParecer2"
                  ? "CONFORME COM APONTAMENTO"
                  : ""
              }}
              {{
                r?.parecertecnico == 3 &&
                r?.nomenclatura == "nomenclaturaParecer3"
                  ? "COM APONTAMENTO"
                  : ""
              }}
              {{
                r?.parecertecnico == 3 &&
                r?.nomenclatura == "nomenclaturaParecer4"
                  ? "COM APONTAMENTO"
                  : ""
              }}
              <!-- parecer 4 -->
              {{
                r?.parecertecnico == 4 &&
                r?.nomenclatura == "nomenclaturaParecer1"
                  ? "REPROVADO"
                  : ""
              }}
              {{
                r?.parecertecnico == 4 &&
                r?.nomenclatura == "nomenclaturaParecer2"
                  ? "NÃO CONFORME"
                  : ""
              }}
              {{
                r?.parecertecnico == 4 &&
                r?.nomenclatura == "nomenclaturaParecer3"
                  ? "NÃO CONFORME"
                  : ""
              }}
              <!-- parecer 5 -->
              {{ r?.parecertecnico == 5 ? "PENDENTE" : "" }}
              <!-- parecer 6 -->
              {{ r?.parecertecnico == undefined ? "PENDENTE" : "" }}
            </td>
            <td>
              {{ r.status == 0 ? "EM ANDAMENTO" : "" }}
              {{ r.status == 1 ? "FINALIZADO" : "" }}
              {{ r.status == 2 ? "AGENDADO" : "" }}
              {{ r.status == 3 ? "CANCELADO" : ""}}
            </td>
            <td>
              <div
                class="d-flex align-items-center justify-content-end"
                *ngIf="r.statusintegracao != null"
              >
                <button
                  class="btn btn-sm btn-outline-success btn-icon mr-1"
                  (click)="openSyncSuccess(modalSyncSuccess, r)"
                  *ngIf="r.statusintegracao == 'OK'"
                >
                  <i class="mdi mdi-check"></i>
                </button>
                <button
                  class="btn btn-sm btn-outline-success btn-icon mr-1"
                  (click)="openSyncSuccess(modalSyncSuccess, r)"
                  *ngIf="r.statusintegracao == 'NAOENCONTRADO'"
                >
                  <i class="mdi mdi-check"></i>
                </button>
                <button
                  class="btn btn-sm btn-outline-danger btn-icon mr-1"
                  (click)="openSyncError(modalSyncError, r)"
                  *ngIf="r.statusintegracao == 'ERRO'"
                >
                  <i class="mdi mdi-sync-alert"></i>
                </button>
              </div>

              <div
                class="d-flex align-items-center justify-content-end"
                *ngIf="r.log_hg != null"
              >
                <button
                  class="btn btn-sm btn-outline-success btn-icon mr-1"
                  (click)="openModalHG(modalHG, r)"
                >
                  HG
                </button>
              </div>
            </td>
            <td class="py-1">
              <div class="d-flex align-items-center justify-content-end">
                <span
                  *ngIf="r.status != 3"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Editar Laudo"
                >
                  <!-- EDITAR ANTIGO -->
                  <a
                    [routerLink]="['/laudo', 'editar', r.tokenlaudo, 0]"
                    rel="noopener noreferrer"
                    target="_blank"
                    class="btn btn-sm btn-primary btn-icon btn-editar mr-1"
                    *ngIf="
                      usuario.permissoes.administrador ||
                      usuario.permissoes.usuario_analista
                    "
                  >
                    <i class="mdi mdi-pencil"></i>
                  </a>
                </span>

                  <!-- EDITAR NOVO -->
                  <!-- <a [routerLink]="['/laudo','editar', r.tokenlaudo, 0]" rel="noopener noreferrer" target="_blank" class="btn btn-sm btn-primary btn-icon mr-1"
                *ngIf="(usuario.permissoes.administrador || usuario.permissoes.usuario_analista) && r.status != 1">
                  <i class="mdi mdi-pencil"></i>
                </a>
                <a [routerLink]="['/laudo','editar', r.tokenlaudo, 0]" rel="noopener noreferrer" target="_blank" class="btn btn-sm btn-primary btn-icon mr-1"
                *ngIf="(usuario.permissoes.administrador || usuario.permissoes.usuario_analista) && (r.status == 1 && usuario.unidade.id == 1) ">
                  <i class="mdi mdi-pencil"></i>
                </a> -->

                <span
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Visualizar laudo"
                >
                  <a
                    [routerLink]="['/laudo', 'visualizar', r.tokenlaudo]"
                    rel="noopener noreferrer"
                    target="_blank"
                    class="btn btn-sm btn-info btn-icon mr-1"
                  >
                    <i class="mdi mdi-eye"></i>
                  </a>
                </span>
                <!-- <span *ngIf="r.status == 2"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Cancelar agendamento"
                >
                  <a
                    (click)="cancelarAgendamento(r.id, r.placa)"
                    style="color:white; padding: 0%; font-weight: bold;"
                    rel="noopener noreferrer"
                    class="btn btn-sm btn-danger btn-icon"
                    *ngIf="
                      usuario.permissoes.administrador ||
                      usuario.permissoes.usuario_analista"
                  >
                  <i class="mdi mdi-table-off"></i>
                  </a>
                </span> -->
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card-footer bg-white row justify-content-between">
      <div class="pb-2 pb-sm-0">
        <ngb-pagination
          [pageSize]="params.per_page"
          [boundaryLinks]="true"
          [collectionSize]="total"
          [(page)]="params.page"
          (pageChange)="nextPage()"
          [maxSize]="5"
          [rotate]="true"
        >
        </ngb-pagination>
      </div>
      <div class="pb-2 pb-sm-0">
        <div class="btn-group" role="group">
          <button
            [disabled]="total == 0"
            (click)="setPageSize(10)"
            [ngClass]="{ active: params.per_page == 10 }"
            type="button"
            class="btn btn-outline-primary"
          >
            10
          </button>
          <button
            [disabled]="total == 0"
            (click)="setPageSize(25)"
            [ngClass]="{ active: params.per_page == 25 }"
            type="button"
            class="btn btn-outline-primary"
          >
            25
          </button>
          <button
            [disabled]="total == 0"
            (click)="setPageSize(50)"
            [ngClass]="{ active: params.per_page == 50 }"
            type="button"
            class="btn btn-outline-primary"
          >
            50
          </button>
          <button
            [disabled]="total == 0"
            (click)="setPageSize(100)"
            [ngClass]="{ active: params.per_page == 100 }"
            type="button"
            class="btn btn-outline-primary"
          >
            100
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
